package de.katoonerie.util

import io.ktor.util.toLowerCasePreservingASCIIRules
import org.jetbrains.compose.web.css.CSSStyleVariable
import org.jetbrains.compose.web.css.StylePropertyValue
import org.jetbrains.compose.web.css.StyleScope
import org.w3c.dom.url.URL

fun String.toURL() = URL(this)

fun String.withoutSuffix(): String {
    val end = when (val dotPosition = indexOf(".")) {
        -1 -> length
        else -> dotPosition
    }
    return substring(0, end)
}

fun String.removeDoubleSlashes(): String {
    return if (startsWith("//")) substring(1) else this
}

fun String?.toBoolean() = when (this?.toLowerCasePreservingASCIIRules()) {
    "true" -> true
    else -> false
}

fun <T : StylePropertyValue> StyleScope.variable(variable: CSSStyleVariable<T>, value: StylePropertyValue) =
    variable("--${variable.name}", value)

fun String.withPreview(preview: Boolean) = when (preview) {
    true -> "$this?preview=true"
    else -> this
}

fun String.withHash(hash: String) = "$this#$hash"
